<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5013 1.66797H14.168C15.7393 1.66797 16.525 1.66797 17.0131 2.15613C17.5013 2.64428 17.5013 3.42995 17.5013 5.0013V17.7096H18.3346C18.6798 17.7096 18.9596 17.9895 18.9596 18.3346C18.9596 18.6798 18.6798 18.9596 18.3346 18.9596H1.66797C1.32279 18.9596 1.04297 18.6798 1.04297 18.3346C1.04297 17.9895 1.32279 17.7096 1.66797 17.7096H2.5013V7.5013C2.5013 5.92995 2.5013 5.14428 2.98946 4.65613C3.47761 4.16797 4.26329 4.16797 5.83464 4.16797H9.16797C10.7393 4.16797 11.525 4.16797 12.0131 4.65613C12.5013 5.14428 12.5013 5.92995 12.5013 7.5013V17.7096H13.7513V7.5013V7.42673C13.7514 6.70537 13.7515 6.04398 13.6791 5.50596C13.5995 4.91349 13.4121 4.28728 12.8971 3.77224C12.382 3.2572 11.7558 3.06979 11.1633 2.99014C10.6329 2.91882 9.98247 2.91789 9.27297 2.91796C9.34322 2.59526 9.46047 2.35179 9.65614 2.15613C10.1443 1.66797 10.93 1.66797 12.5013 1.66797ZM4.3763 6.66797C4.3763 6.32279 4.65613 6.04297 5.0013 6.04297H10.0013C10.3465 6.04297 10.6263 6.32279 10.6263 6.66797C10.6263 7.01314 10.3465 7.29297 10.0013 7.29297H5.0013C4.65613 7.29297 4.3763 7.01314 4.3763 6.66797ZM4.3763 9.16797C4.3763 8.8228 4.65613 8.54297 5.0013 8.54297H10.0013C10.3465 8.54297 10.6263 8.8228 10.6263 9.16797C10.6263 9.51314 10.3465 9.79297 10.0013 9.79297H5.0013C4.65613 9.79297 4.3763 9.51314 4.3763 9.16797ZM4.3763 11.668C4.3763 11.3228 4.65613 11.043 5.0013 11.043H10.0013C10.3465 11.043 10.6263 11.3228 10.6263 11.668C10.6263 12.0131 10.3465 12.293 10.0013 12.293H5.0013C4.65613 12.293 4.3763 12.0131 4.3763 11.668ZM7.5013 15.2096C7.84648 15.2096 8.1263 15.4895 8.1263 15.8346V17.7096H6.8763V15.8346C6.8763 15.4895 7.15613 15.2096 7.5013 15.2096Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'LaspppaIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>